import { all, takeEvery, put, fork, call } from "redux-saga/effects";
import actions from "./actions";

export function* createOrUpdateProduct() {
  yield takeEvery(
    actions.CREATE_OR_UPDATE_PRODUCT_REQUESTED,
    function* (action) {
      try {
        if (action.payload?.expiryDates?.length > 0) {
          const promises = [];
          action.payload.expiryDates.forEach((expiryDate) => {
            promises.push(
              call(actions.createOrUpdateProduct, {
                ...action.payload,
                _id: null,
                supplier_ids: expiryDate.suppliers.map(
                  (supplier) => supplier._id
                ),
                expiry_date: expiryDate.date,
                original_item_id: action.payload?._id,
                is_near_expiry: true,
                quantity: expiryDate.quantity,
                offer_percentage: expiryDate.discount,
              })
            );
          });
          const products = yield all(promises);
          yield put({
            type: actions.CREATE_OR_UPDATE_PRODUCT_SUCCEEDED,
            product: products?.length > 0 ? products[0] : {},
            products: products,
          });
        } else {
          const product = yield call(
            actions.createOrUpdateProduct,
            action.payload
          );
          yield put({
            type: actions.CREATE_OR_UPDATE_PRODUCT_SUCCEEDED,
            product,
          });
        }
      } catch (error) {
        console.log("error", error);
        yield put({
          type: actions.CREATE_OR_UPDATE_PRODUCT_FAILED,
          error: error.response.data,
        });
      }
    }
  );
}
export default function* rootSaga() {
  yield all([fork(createOrUpdateProduct)]);
}
